import { Component } from '@angular/core';

@Component({
  selector: 'app-add-f-button',
  templateUrl: './add-f-button.component.html',
  styleUrls: ['./add-f-button.component.css']
})
export class AddFButtonComponent {

  constructor() { }

}
